import React from 'react'

export function SkeletonTextInput() {
  return <div className='c-skeleton c-skeleton--text-input'></div>
}
